import { Pipe, PipeTransform } from '@angular/core';

import { IRelative } from '../interfaces/users/relative.interface';

@Pipe({
    name: 'filterRelativesByParents',
})
export class FilterRelativesByParentsPipe implements PipeTransform {
    public transform(value: IRelative[], args?: number[]): any {
        return value.filter((relative: IRelative) => args.includes(relative.parentId));
    }
}
